



















import { stringToNumber } from "@/utility/CommonHelper";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class FrekuensiNafas extends Vue {
  @Prop() setNafas: number = null;
  @Prop() setLabel!: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) readonly?: boolean;
  @Ref() readonly inputElement: HTMLInputElement;
  @Prop({ default: () => [] }) errorMessages?: string[];
  // nafas = "";
  label = "";
  placeholder = this.setLabel;
  msg = "";
  validasi = [v => this.cek(v) || this.message()];

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (!this.setNafas) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setNafas")
  valNafas(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("frekNafas", val);
    this.setNafas = val;
  }

  cek(v) {
    this.setNafas = stringToNumber(v);

    if (Number(v) > 200) {
      this.msg = "*Frekuensi Nafas " + v + ", Anda yakin?";
      return false;
    } else return true;
  }

  message() {
    return this.msg;
  }
}
